module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-03.c05a339a.jpg";